import { TelemetryEvent, DataField, DataFieldType } from './DataModels';

export namespace TelemetryEventValidator {
  const INT64_MAX = 9007199254740991;
  const INT64_MIN = -INT64_MAX;

  const MaxEventNameLength = 98; // Client Code = 100 limit; Aria Compact SDK = 98 limit.

  // Starts with "Office", and then at least two more alphanumeric tokens that start with capital letters
  // Tokens are separated by periods.
  const EventNameRegex = /^Office(\.[A-Z][a-zA-Z0-9]*){2,}$/;

  // Contains alphanumeric or _ or .
  const AlphanumericRegex = /^[a-zA-Z0-9_\.]*$/;

  export function validateTelemetryEvent(telemetryEvent: TelemetryEvent) {
    if (!isEventNameValid(telemetryEvent.eventName)) {
      throw new Error('Invalid eventName');
    }

    const eventContract = telemetryEvent.eventContract;
    if (eventContract) {
      if (eventContract.name && !isNameValid(eventContract.name)) {
        throw new Error('Invalid eventContract');
      }
      if (eventContract.dataFields) {
        eventContract.dataFields.forEach(dataField => {
          validateDataField(dataField);
        });
      }
    }

    if (telemetryEvent.dataFields) {
      telemetryEvent.dataFields.forEach(dataField => {
        validateDataField(dataField);
      });
    }
  }

  function isEventNameValid(eventName: string | undefined): boolean {
    if (!eventName || eventName.length > MaxEventNameLength) {
      return false;
    }

    return EventNameRegex.test(eventName);
  }

  function isDataFieldNameValid(dataFieldName: string | undefined): boolean {
    let maxDataFieldNameLength = 100;
    let dataFieldPrefixLength = 5; // Data.

    return !!dataFieldName && isNameValid(dataFieldName) && dataFieldName.length + dataFieldPrefixLength < maxDataFieldNameLength;
  }

  function isNameValid(name: string): boolean {
    return AlphanumericRegex.test(name);
  }

  function validateDataField(dataField: DataField): void {
    if (!isDataFieldNameValid(dataField.name)) {
      throw new Error('Invalid dataField name');
    }

    if (dataField.dataType === DataFieldType.Int64) {
      validateInt(dataField.value);
    }
  }

  export function validateInt(value: any): void {
    if (typeof value !== 'number' || !isFinite(value) || Math.floor(value) !== value || value < INT64_MIN || value > INT64_MAX) {
      throw new Error(`Invalid integer ${JSON.stringify(value)}`);
    }
  }
}
